(() => {
  'use strict';

  function initialiseGallery(gallery) {
    if (gallery.dataset.gsGalleryInitialised === 'true') return;
    const track = gallery.querySelector('[data-gs-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-gs-gallery-slide]'));
    if (!track || !slides.length) return;
    gallery.dataset.gsGalleryInitialised = 'true';
    const previous = gallery.querySelector('[data-gs-gallery-prev]');
    const next = gallery.querySelector('[data-gs-gallery-next]');
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gs-gallery-thumbnail]'));
    const segments = Array.from(gallery.querySelectorAll('[data-gs-gallery-progress] > span'));
    const status = gallery.querySelector('[data-gs-gallery-status]');
    const page = gallery.closest('[data-gs-starter]');
    const primary = gallery.querySelector('[data-gs-bundle-image]');
    const primaryThumbnail = gallery.querySelector('[data-gs-gallery-primary-thumb]');
    let active = 0;
    let requested = null;
    let settleTimer;
    let frame;

    function slideOffset(index) {
      return slides[index].offsetLeft - slides[0].offsetLeft;
    }
    function closestIndex() {
      return slides.reduce((best, slide, index) =>
        Math.abs(slideOffset(index) - track.scrollLeft) < Math.abs(slideOffset(best) - track.scrollLeft) ? index : best, 0);
    }
    function paint(index) {
      active = Math.max(0, Math.min(slides.length - 1, index));
      if (previous) previous.disabled = active === 0;
      if (next) next.disabled = active === slides.length - 1;
      thumbnails.forEach((thumbnail, index) => thumbnail.setAttribute('aria-current', String(index === active)));
      segments.forEach((segment, index) => segment.classList.toggle('is-active', index === active));
      slides.forEach((slide, index) => {
        const label = (gallery.dataset.slideLabel || 'Slide [index] of [count]').split('[index]').join(String(index + 1)).split('[count]').join(String(slides.length));
        slide.setAttribute('aria-label', label);
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        const video = slide.querySelector('video');
        if (video && index !== active && !video.paused) video.pause();
      });
      if (status) status.textContent = (gallery.dataset.slideLabel || 'Slide [index] of [count]').split('[index]').join(String(active + 1)).split('[count]').join(String(slides.length));
    }
    function goTo(index, smooth = true) {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      requested = target;
      paint(target);
      track.scrollTo({ left: slideOffset(target), behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
    }
    function settle() {
      requested = null;
      paint(closestIndex());
    }
    track.addEventListener('scroll', () => {
      window.clearTimeout(settleTimer);
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => { if (requested === null) paint(closestIndex()); });
      settleTimer = window.setTimeout(settle, 160);
    }, { passive: true });
    track.addEventListener('scrollend', settle);
    track.addEventListener('pointerdown', () => { requested = null; }, { passive: true });
    track.addEventListener('touchstart', () => { requested = null; }, { passive: true });
    if (previous) previous.addEventListener('click', () => goTo(active - 1));
    if (next) next.addEventListener('click', () => goTo(active + 1));
    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => goTo(index)));
    gallery.addEventListener('keydown', event => {
      if (event.target instanceof Element && event.target.closest('video')) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') goTo(0);
      else if (event.key === 'End') goTo(slides.length - 1);
      else goTo(active + (event.key === 'ArrowRight' ? 1 : -1));
    });
    if (page) page.addEventListener('change', event => {
      if (!(event.target instanceof HTMLInputElement) || event.target.name !== 'gs-plan') return;
      window.requestAnimationFrame(() => {
        if (primary && primaryThumbnail) primaryThumbnail.src = primary.src;
        goTo(0, false);
      });
    });
    if (primary && primaryThumbnail) {
      const observer = new MutationObserver(() => { primaryThumbnail.src = primary.src; });
      observer.observe(primary, { attributes: true, attributeFilter: ['src'] });
    }
    if (window.ResizeObserver) new ResizeObserver(() => goTo(active, false)).observe(track);
    else window.addEventListener('resize', () => goTo(active, false));
    paint(0);
  }

  function initialiseAll() { document.querySelectorAll('[data-gs-gallery]').forEach(initialiseGallery); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
